/* Keep the current page visible without moving the document vertically. */
document.querySelectorAll('.emp-nav').forEach((nav) => {
  const active = nav.querySelector('[aria-current="page"]');
  if (!active) return;
  const reveal = () => {
    const bounds = nav.getBoundingClientRect();
    const tab = active.getBoundingClientRect();
    if (tab.left < bounds.left || tab.right > bounds.right) {
      nav.scrollLeft += tab.left - bounds.left - (bounds.width - tab.width) / 2;
    }
  };
  requestAnimationFrame(reveal);
  if (document.fonts) document.fonts.ready.then(reveal);
});
